import { faBell, faBellSlash, faCheck, faSync } from '@fortawesome/free-solid-svg-icons';
import { PushSubscriptionHealth } from '../../state/pwa-push-notification/pwa-push-notification.state';
import { MenuEntryModel } from './menu-entry.model';

/**
 * Maps live push-subscription health to the "Subscribe to Notification" side-menu entry: a
 * clickable invitation to subscribe while not subscribed, a non-actionable status indicator once
 * subscribed or while a silent renewal is in flight, and — regardless of health — a non-actionable
 * "unsupported" indicator when this browsing context can't do push at all (e.g. iOS outside a
 * Home-Screen-installed session).
 */
export function buildPushNotificationMenuEntry(
    health: PushSubscriptionHealth,
    isSupported: boolean,
    translate: (key: string) => string,
    onSubscribeClick: () => void,
): MenuEntryModel {
    if (!isSupported) {
        return new MenuEntryModel(
            translate('SIDEMENU_BUTTON_NOTIFICATIONS_UNSUPPORTED'),
            () => undefined,
            faBellSlash,
            true,
            true,
        );
    }

    switch (health) {
        case PushSubscriptionHealth.Subscribed:
            return new MenuEntryModel(
                translate('SIDEMENU_BUTTON_NOTIFICATIONS_SUBSCRIBED'),
                () => undefined,
                faCheck,
                true,
                true,
            );
        case PushSubscriptionHealth.Renewing:
            return new MenuEntryModel(
                translate('SIDEMENU_BUTTON_NOTIFICATIONS_RENEWING'),
                () => undefined,
                faSync,
                true,
                true,
            );
        case PushSubscriptionHealth.NotSubscribed:
        case PushSubscriptionHealth.Unchecked:
            return new MenuEntryModel(
                translate('SIDEMENU_BUTTON_SUBSCRIBE_TO_NOTIFICATIONS'),
                onSubscribeClick,
                faBell,
            );
    }
}
